// extracted by mini-css-extract-plugin
export default {"employee-container":"Deduction_employee-container__5Z0-P"};